import { useState } from "react";
import {
  Box,
  Button,
  Modal,
  IconButton,
  Tooltip,
  Divider,
} from "@mui/material";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import BackupIcon from "@mui/icons-material/Backup";
import CloseIcon from "@mui/icons-material/Close";
import Swal from "sweetalert2";
import axios from '../../../utils/axios';

const previewStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "70%",
  height: "80vh",
  bgcolor: "background.paper",
  borderRadius: "10px",
  boxShadow: 24,
  p: 2,
};

const FundTransferPDFNoteUpload = ({ label, file, setFile, fundTransferId, existingFile }) => {
  const [fileURL, setFileURL] = useState("");
  const [previewOpen, setPreviewOpen] = useState(false);

  // -----------------------------------------
  //  VIEW EXISTING PDF FROM SERVER
  // -----------------------------------------
  const handleViewExisting = async () => {
    try {
      const response = await axios.post(
        `/fund-transfer-requests/get-note-file/${fundTransferId}`,
        { filename: existingFile },
        { responseType: "blob" } // important for PDF
      );

      const blobURL = URL.createObjectURL(response.data);
      setFileURL(blobURL);
      setPreviewOpen(true);
    } catch (err) {
      Swal.fire("Error", "Unable to load file.", "error");
    }
  };

  // -----------------------------------------
  //  UPLOAD PDF HANDLER
  // -----------------------------------------
  const handleUpload = async (e) => {
    const selected = e.target.files[0];
    if (!selected) return;

    if (selected.type !== "application/pdf") {
      Swal.fire("Invalid File!", "Please upload a PDF file.", "warning");
      return;
    }

    if (selected.size / 1024 > 1024) {
      Swal.fire("File Too Large!", "PDF size must be 1 MB or smaller.", "warning");
      return;
    }

    setFile(selected);
    setFileURL(URL.createObjectURL(selected));
  };

  const handleRemove = () => {
    setFile(null);
    setFileURL("");
  };

  return (
    <Box sx={{ border: "1px solid #ddd", p: 2, borderRadius: "10px", background: "#fafafa" }}>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <strong style={{ fontSize: "15px" }}>{label}</strong>

        {file && (
          <Tooltip title="Remove File">
            <IconButton size="small" onClick={handleRemove}>
              <CloseIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        )}
      </div>

      <Divider sx={{ my: 1 }} />

      <Box sx={{ display: "flex", alignItems: "center", gap: 2, mt: 1 }}>

        {/* UPLOAD BUTTON */}
        <label htmlFor={label} style={{ cursor: "pointer" }}>
          <Button variant="outlined" startIcon={<BackupIcon />} component="span" size="small">
            Upload PDF
          </Button>
        </label>

        <input
          id={label}
          type="file"
          accept="application/pdf"
          style={{ display: "none" }}
          onChange={handleUpload}
        />

        {/* PREVIEW UPLOADED FILE */}
        {file && (
          <Button
            variant="contained"
            size="small"
            startIcon={<RemoveRedEyeIcon />}
            onClick={() => setPreviewOpen(true)}
          >
            Preview
          </Button>
        )}

        {/* VIEW EXISTING FILE FROM SERVER */}
     
        {existingFile ? !file && (
          <Button
            variant="outlined"
            size="small"
            startIcon={<RemoveRedEyeIcon />}
            onClick={handleViewExisting}
          >
            View
          </Button>
        )
         : <p>No File Uploaded Yet !!!</p>}
      </Box>

      {/* FILE DETAILS */}
      {file && (
        <Box sx={{ mt: 2 }}>
          <p><strong>Name:</strong> {file.name}</p>
          <p><strong>Size:</strong> {Math.round(file.size / 1024)} KB</p>
        </Box>
      )}

      {/* PREVIEW MODAL */}
      <Modal open={previewOpen} onClose={() => setPreviewOpen(false)}>
        <Box sx={previewStyle}>
          <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "10px" }}>
            <h3>PDF Preview</h3>
            <IconButton onClick={() => setPreviewOpen(false)}>
              <CloseIcon />
            </IconButton>
          </div>

          {fileURL ? (
            <iframe src={fileURL} width="100%" height="90%" style={{ border: "none" }} />
          ) : (
            <p>No file selected</p>
          )}
        </Box>
      </Modal>
    </Box>
  );
};

export default FundTransferPDFNoteUpload;
